var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunshadeOpenSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,0H8C6.3457031,0,5,1.3457031,5,3v26c0,1.6542969,1.3457031,3,3,3h16c1.6542969,0,3-1.3457031,3-3V3 C27,1.3457031,25.6542969,0,24,0z M8,2h16c0.5517578,0,1,0.4487305,1,1v8h-8V8h1.5 c0.1943359,0,0.3701172-0.1123047,0.453125-0.2880859c0.0820312-0.175293,0.0556641-0.3828125-0.0693359-0.5322266l-2.5-3 c-0.1894531-0.2275391-0.578125-0.2275391-0.7675781,0l-2.5,3c-0.125,0.1494141-0.1513672,0.3569336-0.0693359,0.5322266 C13.1298828,7.8876953,13.3056641,8,13.5,8H15v3H7V3C7,2.4487305,7.4482422,2,8,2z M24,30H8c-0.5517578,0-1-0.4482422-1-1V13h8v3 h-1.5c-0.1943359,0-0.3701172,0.1123047-0.453125,0.2880859c-0.0820312,0.1757812-0.0556641,0.3828125,0.0693359,0.5322266l2.5,3 C15.7109375,19.9345703,15.8515625,20,16,20s0.2890625-0.0654297,0.3837891-0.1796875l2.5-3 c0.125-0.1494141,0.1513672-0.3564453,0.0693359-0.5322266C18.8701172,16.1123047,18.6943359,16,18.5,16H17v-3h8v16 C25,29.5517578,24.5517578,30,24,30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 14,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunshadeOpenSmall);
export default __webpack_public_path__ + "static/media/sunshade-open--small.93eb9a36fef80c179d0fc2fb09af0938.svg";
export { ForwardRef as ReactComponent };